/**
 * Generic builder for features
 * ----------------------------
 * Wires:
 * - State management dependency (e.g., Redux dispatch, Zustand store, etc.)
 * - feature repository (infra adapter)
 * - feature service (application layer)
 *
 * This function is state-management agnostic - it accepts any dependency type D
 * that the repository factory needs. This allows swapping Redux for Zustand or
 * other state management libraries without changing this core builder.
 *
 * @template D - Dependency type (e.g., AppDispatch for Redux, Store for Zustand)
 * @template R - Repository type
 * @template S - Service type
 */
export function baseBuild<D, R, S>(
  repoFactory: (dependency: D) => R,
  serviceFactory: (repo: R) => S,
  dependency: D
): { service: S } {
  const repo = repoFactory(dependency);
  const service = serviceFactory(repo);
  return { service };
}

